<div class="np-ais">
  <header class="np-ais-head">
    <div>
      <h5><i class="bi bi-gear"></i> AI 설정</h5>
      <p>AI가 참고할 사내 지식(매뉴얼, 업무 규칙, 절차)을 등록합니다. 채팅에서 회사·시스템 질문을 받으면 AI가 여기서 찾아 읽고 답합니다.</p>
    </div>
    <nav class="np-ais-tabs">
      <span class="active"><i class="bi bi-journal-text"></i> 지식</span>
    </nav>
  </header>

  <div class="np-ais-body">
    <!-- ===== 목록 ===== -->
    <aside class="np-ais-list">
      <div class="np-ais-list-tools">
        <div class="np-ais-search">
          <i class="bi bi-search"></i>
          <input type="text" placeholder="제목·요약·본문 검색" [(ngModel)]="keyword" (ngModelChange)="onKeywordChange()">
        </div>
        <select class="form-select form-select-sm" [(ngModel)]="categoryFilter" (ngModelChange)="loadList()">
          <option value="">전체 분류</option>
          <option *ngFor="let c of categories" [value]="c">{{ c }}</option>
        </select>
        <button type="button" class="btn btn-sm btn-primary" (click)="newKnowledge()"><i class="bi bi-plus-lg"></i> 새 지식</button>
      </div>

      <div class="np-ais-items">
        <div *ngIf="listLoading && list.length === 0" class="np-ais-empty">불러오는 중…</div>
        <div *ngIf="!listLoading && list.length === 0" class="np-ais-empty">
          {{ keyword || categoryFilter ? '찾는 지식이 없습니다' : '등록한 지식이 없습니다' }}
        </div>
        <button type="button" *ngFor="let k of list; trackBy: trackById" class="np-ais-item"
          [class.active]="form?.id === k.id" [class.off]="!k.enabled" (click)="open(k)">
          <span class="np-ais-item-top">
            <span *ngIf="k.category" class="np-ais-cat">{{ k.category }}</span>
            <span *ngIf="!k.enabled" class="np-ais-off">사용 안 함</span>
            <span *ngIf="k.markdown" class="np-ais-md" title="마크다운">MD</span>
          </span>
          <span class="np-ais-item-title">{{ k.title }}</span>
          <span *ngIf="k.summary" class="np-ais-item-summary">{{ k.summary }}</span>
          <span class="np-ais-item-meta">{{ k.length | number }}자 · {{ k.updatedAt | date: 'yy.MM.dd HH:mm' }}<ng-container *ngIf="k.updatedByName"> · {{ k.updatedByName }}</ng-container></span>
        </button>
      </div>
    </aside>

    <!-- ===== 편집 ===== -->
    <main class="np-ais-editor">
      <div *ngIf="!form" class="np-ais-placeholder">
        <i class="bi bi-journal-plus"></i>
        <p>왼쪽에서 지식을 고르거나 <a href="#" (click)="$event.preventDefault(); newKnowledge()">새 지식</a>을 만드세요.</p>
        <ul>
          <li>긴 매뉴얼은 <code>#</code>, <code>##</code> 제목으로 나눠 쓰면 AI가 필요한 부분만 읽습니다.</li>
          <li>한 줄 요약은 AI가 검색 결과에서 먼저 봅니다. 무엇에 대한 문서인지 적으세요.</li>
          <li>비밀번호·키 같은 비밀값은 넣지 마세요. 지식은 외부 AI(Google)로 전송됩니다.</li>
        </ul>
      </div>

      <form *ngIf="form" class="np-ais-form" (submit)="$event.preventDefault(); save()">
        <div class="np-ais-form-row">
          <label class="np-ais-field cat">
            <span>분류</span>
            <input type="text" class="form-control form-control-sm" name="category" [(ngModel)]="form.category"
              list="np-ais-categories" maxlength="100" placeholder="예: 작업지시">
            <datalist id="np-ais-categories">
              <option *ngFor="let c of categories" [value]="c"></option>
            </datalist>
          </label>
          <label class="np-ais-field title">
            <span>제목 <em>*</em></span>
            <input type="text" class="form-control form-control-sm" name="title" [(ngModel)]="form.title" maxlength="200"
              placeholder="예: 작업지시 홀딩과 해제 절차" required>
          </label>
        </div>
        <label class="np-ais-field">
          <span>한 줄 요약</span>
          <input type="text" class="form-control form-control-sm" name="summary" [(ngModel)]="form.summary" maxlength="500"
            placeholder="AI가 검색 결과에서 먼저 봅니다">
        </label>

        <div class="np-ais-content-head">
          <div class="np-ais-editor-tabs">
            <button type="button" [class.active]="tab === 'edit'" (click)="setTab('edit')">편집</button>
            <button type="button" [class.active]="tab === 'preview'" (click)="setTab('preview')">미리보기</button>
          </div>
          <div class="np-ais-switches">
            <label class="form-check form-switch">
              <input class="form-check-input" type="checkbox" name="markdown" [(ngModel)]="form.markdown">
              <span class="form-check-label">마크다운</span>
            </label>
            <label class="form-check form-switch">
              <input class="form-check-input" type="checkbox" name="enabled" [(ngModel)]="form.enabled">
              <span class="form-check-label">사용</span>
            </label>
          </div>
        </div>

        <textarea *ngIf="tab === 'edit'" class="np-ais-content" name="content" [(ngModel)]="form.content"
          [maxlength]="contentMaxLength" spellcheck="false"
          [placeholder]="form.markdown ? '# 제목\n\n## 절차\n1. ...' : '본문을 입력하세요'"></textarea>
        <div *ngIf="tab === 'preview'" class="np-ais-preview">
          <div *ngIf="form.markdown; else plain" class="np-ais-render" [innerHTML]="previewHtml"></div>
          <ng-template #plain><pre class="np-ais-plain">{{ form.content }}</pre></ng-template>
        </div>

        <div *ngIf="errorText" class="np-ais-error"><i class="bi bi-exclamation-circle"></i> {{ errorText }}</div>

        <footer class="np-ais-actions">
          <span class="np-ais-meta">
            {{ form.content.length | number }} / {{ contentMaxLength | number }}자
            <ng-container *ngIf="form.updatedAt"> · {{ form.updatedAt | date: 'yy.MM.dd HH:mm' }} {{ form.updatedByName }} 고침</ng-container>
            <span *ngIf="dirty" class="np-ais-dirty">· 저장하지 않음</span>
            <span *ngIf="savedText" class="np-ais-saved">· {{ savedText }}</span>
          </span>
          <span class="np-ais-buttons">
            <button *ngIf="form.id" type="button" class="btn btn-sm btn-outline-danger" (click)="remove()">삭제</button>
            <button type="button" class="btn btn-sm btn-light" (click)="close()">닫기</button>
            <button type="submit" class="btn btn-sm btn-primary" [disabled]="saving || !dirty" title="Ctrl+S">
              {{ saving ? '저장 중…' : '저장' }}
            </button>
          </span>
        </footer>
      </form>
    </main>
  </div>
</div>
